// extracted by mini-css-extract-plugin
export var boxItems = "_90-1";
export var boxItemsLg = "_90-2";
export var button = "_90-7";
export var buttonHoverless = "_90-9";
export var buttonLg = "_90-8";
export var filterGroupBox = "_90-0";
export var icon = "_90-3";
export var iconSecondary = "_90-6";
export var iconWrapper = "_90-4";
export var iconWrapperLg = "_90-5";
export var truncatedLabel = "_90-a";